var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 39,
    viewBox: "0 0 50 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H42C46.4183 0 50 3.58172 50 8V31C50 35.4183 46.4183 39 42 39H0V0Z",
    fill: "#45B549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.647 11.4062V14.2188H28.7687V11.4062H32.2771V28H16.1387V11.4062H19.647ZM28.7687 22.6562H19.647V23.5001H28.7687V22.6562ZM28.7687 19.8437H19.647V20.6876H28.7687V19.8437ZM28.7687 17.0312H19.647V17.8751H28.7687V17.0312ZM27.7162 10V13.3749H20.6995V10H27.7162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAddress);
export default __webpack_public_path__ + "static/media/CopyAddress.be4c7d06a7492ae55d2849809eeae10a.svg";
export { ForwardRef as ReactComponent };